import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { fromEvent, merge, Observable, of, shareReplay, throwError } from 'rxjs';
import { map, mergeMap, startWith, tap } from 'rxjs/operators';
import { CONNECTION_ERROR_CODES } from '../../enums/connection-error-codes.enum';

@Injectable({
    providedIn: 'root',
})
export class ConnectivityService {
    // this is to set the sync indicator state correctly
    public isOnline$: Observable<boolean>;
    public isOnlineButWithErrors$: Observable<string>;
    public constructor(@Inject(LogInstanceToken) private readonly log: LogInterface) {
        this.isOnline$ = merge(
            fromEvent(window, 'online').pipe(map(() => true)),
            fromEvent(window, 'offline').pipe(map(() => false)),
        ).pipe(
            startWith(navigator.onLine),
            tap((value) => this.log.debug(`ConnectivityService : isOnline: ${value}`)),
            shareReplay(1),
        );

        this.isOnlineButWithErrors$ = this.isOnline$.pipe(
            mergeMap((online) =>
                online ? of('Internet') : throwError(() => CONNECTION_ERROR_CODES.NO_INTERNET_CONNECTION),
            ),
        );
    }

    public isInternetConnectionAvailable(): boolean {
        return navigator.onLine;
    }
}
